import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-panel-h0-a0-md1',
    templateUrl: './panel-h0-a0-md1.component.html',
    styleUrls: [
        '../panels.scss',
        './panel-h0-a0-md1.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PanelH0A0MD1Component
{
}
